import axios from 'axios'
import { Message } from 'view-design'

// create an axios instance
const service = axios.create({
    baseURL: '/api', // url = base url + request url
    // withCredentials: true, // send cookies when cross-domain requests
    timeout: 10000 // request timeout
})


// request interceptor
service.interceptors.request.use(
    config => {
        // do something before request is sent
        return config
    },
    error => {
        // do something with request error
        console.log(error) // for debug
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    response => {
        const res = response.data

        // if the custom code is not 200, it is judged as an error.
        if (res.code !== 200) {
            Message({
                message: res.message || 'Error',
                type: 'error',
                duration: 5 * 1000
            })
            return Promise.reject(new Error(res.message || 'Error'))
        } else {
            return res
        }
    },
    error => {
        console.log('err' + error) // for debug
        const { response, message } = error
        console.log(response, message)
        if (error.response && error.response.data) {
            const { status, data } = response
            Message({
                message: data.msg || message,
                type: 'error',
                duration: 5 * 1000
            })
            return Promise.reject(error)
        } else {
            let { message } = error
            console.log('message ' + message)
            if (message === 'Network Error') {
                message = '后端接口连接异常'
            }
            if (message.includes('timeout')) {
                message = '后端接口请求超时'
            }
            if (message.includes('Request failed with status code')) {
                const code = message.substr(message.length - 3)
                message = '后端接口' + code + '异常'
            }
            // Message({
            //   message: message || `后端接口未知异常`,
            //   type: 'error',
            //   duration: 5 * 1000
            // })
            return Promise.reject(error)
        }
    }
)

// export default service
export const request = service



// WEBPACK FOOTER //
// ./src/utils/index.js